// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/realEstateSearchDetail.scss'

// MasterSlider
async function getMasterSlider () {
  import(/* webpackChunkName: "masterSlider", webpackPrefetch: true */ './js/components/masterSlider.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Gallery
async function getPhotoswipe () {
  import(/* webpackChunkName: "photoswipe", webpackPrefetch: true */ './js/components/photoswipe.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Real Estate Search Form
async function getRESForm ($f) {
  $f.load()
  import(/* webpackChunkName: "realEstateSearchForm", webpackPrefetch: true */ './js/components/realEstateSearchForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm", webpackPrefetch: true */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion master slider
  const $m = $('#masterslider')
  if ($m.length) {
    $m.waypoint(function () {
      getMasterSlider()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des galeries
  const $g = $('.gallery')
  if ($g.length) {
    $g.waypoint(function () {
      getPhotoswipe()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de recherche des biens immobiliers
  const $resf = $('.resform:not(.modal)')
  if ($resf.length) {
    $resf.waypoint(function () {
      getRESForm($resf)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire de contact
  const $cf = $('form[name="cForm"]')
  $cf.waypoint(function () {
    getCForm($cf)
    this.destroy()
  }, {
    offset: '100%'
  })

  const $mn = $('#filters-nav')
  const $h = $('#header')
  $h.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($h.find('.navbar-collapse').hasClass('show')) { $mn.parents('.sticky-top').css('z-index', '999') } else { $mn.parents('.sticky-top').css('z-index', '1020') }
  })
  $mn.find('.navbar-toggler, .navbar-close').on('click', function () {
    if ($mn.find('.navbar-collapse').hasClass('show')) {
      $mn.parents('.sticky-top').css('z-index', '1020')
      $('body').addClass('open')
    } else {
      $mn.parents('.sticky-top').css('z-index', '999')
      $('body').removeClass('open')
    }
  })
})
